import { useAdminMonitoring } from '@/hooks/useAdminMonitoring'
import { MonitoringSettings } from './MonitoringSettings'
import { MonitoringHero } from './MonitoringHero'
import { MonitoringHistory } from './MonitoringHistory'
import { MonitoringKpis } from './MonitoringKpis'
import { MonitoringProbeTable } from './MonitoringProbeTable'
import styles from './MonitoramentoPage.module.css'

export function MonitoramentoPage() {
  const {
    data,
    isLoading,
    isRefreshing,
    isCheckingNow,
    error,
    isPaused,
    intervalSeconds,
    setIntervalSeconds,
    checkNow,
  } = useAdminMonitoring()

  return (
    <div className={styles.page} data-status={data?.status}>
      <div className={styles.masthead}>
        <MonitoringHero
          panel={data}
          isLoading={isLoading}
          isRefreshing={isRefreshing}
          isCheckingNow={isCheckingNow}
          error={error}
        />
        {data ? (
          <MonitoringSettings
            value={intervalSeconds}
            disabled={isLoading}
            loading={isCheckingNow}
            refreshing={isRefreshing}
            paused={isPaused}
            onChange={setIntervalSeconds}
            onCheckNow={checkNow}
          />
        ) : null}
      </div>

      {error ? (
        <p className={styles.error} role="alert">
          {error}
        </p>
      ) : null}

      {data ? (
        <>
          <MonitoringKpis payments={data.payments} />
          <MonitoringProbeTable probes={data.probes} />
          <MonitoringHistory history={data.history} />
        </>
      ) : null}
    </div>
  )
}
